import { useTranslation } from 'react-i18next';

import type { TabsNavigation } from '@/types/ui';

import { cn } from '@/lib/utils';

import { useIsMobile } from '@/hooks';

export const PageTabs = (props: TabsNavigation) => {
  const { tabs } = props;

  const { t } = useTranslation();
  const isMobile = useIsMobile();

  if (!tabs?.length) {
    return null;
  }

  return (
    <div
      className={cn(
        'bg-muted/80 text-muted-foreground border-border mb-5 flex w-full items-stretch justify-center gap-2 rounded-lg border p-2 shadow-sm',
        isMobile && 'flex-wrap gap-1.5 p-1.5',
      )}
    >
      {tabs.map((tab) => (
        <a
          key={tab.href}
          href={tab.href}
          className={cn(
            'text-muted-foreground hover:bg-background hover:text-foreground flex flex-1 items-center justify-center gap-1.5 rounded-md border border-transparent px-3 py-1 text-center text-sm font-medium transition-all duration-200 hover:shadow-md [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*="size-"])]:size-4',
            isMobile && 'flex-none px-2 py-0.5 text-xs',
            tab.active &&
              'bg-primary text-primary-foreground hover:bg-primary/90 hover:text-primary-foreground shadow-md',
          )}
        >
          {t(tab.text)}
        </a>
      ))}
    </div>
  );
};
